import { useCallback, useState } from "react"
import {
  FLOW_MENU_GLOBAL_PINS_KEY,
  flowMenuPinStorageKey,
  flowMenuProjectPinsKey,
  parseFlowMenuPins,
  toggleFlowMenuPin,
} from "@/lib/flow-menu-pins"

function readPins(storageKey: string): string[] {
  try {
    return parseFlowMenuPins(localStorage.getItem(storageKey))
  } catch {
    return []
  }
}

function readAllPins(projectId: number): string[] {
  return [...readPins(FLOW_MENU_GLOBAL_PINS_KEY), ...readPins(flowMenuProjectPinsKey(projectId))]
}

/** Закреплённые пункты меню «Добавить ноду». Хранятся в браузере. */
export function useFlowMenuPins(projectId: number): [string[], (key: string) => void] {
  const [pins, setPins] = useState(() => readAllPins(projectId))

  const toggle = useCallback(
    (key: string) => {
      const storageKey = flowMenuPinStorageKey(key, projectId)
      try {
        localStorage.setItem(storageKey, JSON.stringify(toggleFlowMenuPin(readPins(storageKey), key)))
      } catch {
        /* ignore */
      }
      setPins(readAllPins(projectId))
    },
    [projectId],
  )

  return [pins, toggle]
}
